<template>
  <div class="DownloadCenter">
    <!-- 轮播图：主推产品 -->
    <el-row>
      <el-col :span="24"
        ><div class="grid-content">
          <el-carousel
            trigger="click"
            height="400px"
            style="width: 100%; margin-top: 6px"
          >
            <el-carousel-item
              v-for="(item, index) in instruments"
              :key="index"
              style="background-color: #63626237"
            >
              <!-- 仪器图片卡片 -->
              <div class="product_center_top">
                <div class="instrument-card">
                  <img
                    :src="item.url"
                    alt="Instrument"
                    style="width: 50%; margin: 0 auto; height: auto"
                  />
                </div>
                <!-- 仪器概述卡片 -->
                <div class="instrument-card">
                  <div class="instrument-description">
                    <strong>主推产品介绍：</strong>{{ item.productIntro }}
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col>
    </el-row>
    <div class="downB">
      <div style="width: 100%; margin: 0 auto">
        <div class="right_letter"></div>
      </div>
      <h2>下载中心</h2>
      <h3>Download Center</h3>
      <div class="btn">
        <el-button type="primary" round @click="download(2)"
          >产品说明书</el-button
        >
        <el-button type="primary" round @click="download(3)"
          >工具软件</el-button
        >
        <el-button type="primary" round @click="download(4)"
          >操作视频</el-button
        >
      </div>
      <div class="content-container">
        <div class="ContentA">
          <div class="tab">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column
                prop="name"
                label="名称"
                width="550"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="createdDate"
                label="更新时间"
                width="400"
                align="center"
              >
              </el-table-column>

              <el-table-column
                prop="address"
                label="下载"
                width="345"
                align="center"
              >
                <template slot-scope="scope">
                  <el-link type="primary" :href="scope.row.url">
                    <el-button
                      type="primary"
                      icon="el-icon-download"
                    ></el-button
                  ></el-link>
                </template>
                <!-- 减少宽度 -->
                <!-- <el-button type="primary" icon="el-icon-download"></el-button> -->
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- <ContentA v-if="currentContent === 'A'" />
        <ContentB v-if="currentContent === 'B'" />
        <ContentC v-if="currentContent === 'C'" /> -->
        <!-- 如果有更多内容，可以继续添加 -->
      </div>
    </div>
  </div>
</template>
<script>
import { getDicList, getProductList, getDownloadList } from "@/api";
// import ContentA from "./ContentA.vue";
// import ContentB from "./ContentB.vue";
// import ContentC from "./ContentC.vue";
export default {
  name: "DownloadCenter",
  components: {
    // ContentA,
    // ContentB,
    // ContentC,
  },
  data() {
    return {
      tableData: [
        {
          date: "2016-05-02",
          name: "xxxxxxxxxxxxxxx说明书",
          address: "",
        },
      ],
      instruments: [],
      Items: [],
      dataitem: [],
      options: [],
      value: "",
      queryForm: {
        query: "",
        query2: "",
        pageNum: 1,
        pageSize: 12,
      },
      downloadForm: {
        query: "",
        query2: "2",
        pageNum: 1,
        pageSize: 12,
      },
      currentContent: "A", // 默认显示内容A
    };
  },
  methods: {
    changeContent(contentType) {
      this.currentContent = contentType; // 更新currentContent的值，以切换显示的内容
    },
    initProduct() {
      getProductList(this.queryForm)
        .then((res) => {
          if (res.code === "200") {
            this.total = res.data.total;
            this.Items = res.data.records;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    initloadProduct() {
      const Form = {
        query: "",
        query2: "",
        pageNum: 1,
        pageSize: 12,
      };
      getProductList(Form)
        .then((res) => {
          if (res.code === "200") {
            this.dataitem = res.data.records;
            // 获取前三条数据
            this.instruments = this.dataitem.slice(0, 3);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    download(data) {
      this.downloadForm.query2 = data;
      getDownloadList(this.downloadForm)
        .then((res) => {
          console.log("res", res);
          if (res.code === "200") {
            this.tableData = res.data.records;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cotegoryOptions() {
      getDicList("productcategory")
        .then((res) => {
          if (res.code === "200") {
            console.log(res);
            this.options = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.initloadProduct();
    this.initProduct();
    this.cotegoryOptions();
    this.download(2);
  },
};
</script>
<style lang="scss" scoped>
.ContentA {
  margin: auto;
}
.ContentA .tab .el-table {
  font-size: 1em;
}

.ContentA .tab .el-button {
  background: rgb(153, 151, 151);
  border: 0px;
}
.ContentA .tab .el-button:hover {
  background: rgb(20, 78, 238);
  border: 0px;
}
h2 {
  text-align: right;
  text-align: left;
  color: blue;
  margin-top: 10px;
}
h3 {
  text-align: left;
  color: grey;
  margin-bottom: 30px;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.product_center_top {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start; /*确保卡片对齐*/
}
.instrument-card {
  /* 卡片样式 */
  border: 1px solid #333;
  border-radius: 30px;
  background-color: #fff; /* 背景色 */
  overflow: auto; /* 当内容超出时显示滚动条 */
  width: 40%;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 25px;
  margin-bottom: 15px;
  text-align: center;
  /* 添加阴影效果 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease; /* 过渡效果 */
}
.instrument-card:hover {
  cursor: pointer;
}
.instrument-image {
  /* 图片样式 */
  width: 100%;
  display: block;
  height: 316px;
  border-radius: 30px 30px 0 0; /* 图片上圆角 */
}

.instrument-description {
  /* 概述样式 */
  padding: 86px;
  font-size: 1em;
  margin: 0 auto;
  background-color: #fff; /* 背景色 */
  border-radius: 0 0 30px 30px; /* 描述下圆角 */
}
.DownloadCenter {
  background-color: #f8f8f8;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.instrument-image {
  /* 图片样式 */
  width: 100%;
  display: block;
}
.right_letter {
  border-bottom: 2px solid rgba(204, 204, 204, 0.9411764706);
  text-align: right;
  margin-top: 69px;
}
.instrument-description {
  /* 概述样式 */
  padding: 30px;
  font-size: 1em;
  margin: 0 auto;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  // background-color: #ccc;
}
.downB {
  width: 88%;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 60px;
}
.btn {
  margin-bottom: 40px;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  display: flex;
}
.btn .el-button {
  background-color: rgb(50, 62, 202);
  display: flex; /* 使用flex布局来确保按钮并排显示 */
  justify-content: space-between; /* 默认让按钮之间等距分布 */
  width: auto;
  height: 45px;
  font-size: 1em;
}
.btn .el-button {
  margin-bottom: 10px; /* 假设你希望按钮之间有一些垂直间距 */
}
.btn .el-button:hover {
  background-color: aqua;
  color: #333;
  transition: 0.3s;
}
</style>
